import { items, ItemTypes } from '@wg/wows-entities/const';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { memo } from 'react';

import { Col, Container, Row } from '~/Components/Grid/Grid';

import styles from './StatisticsHeader.scss';

export interface StatisticsHeaderOptions extends Pick<MarkOfExcellenceStat, 'achieved_at' | 'percentile'> {
  battles_left?: number;
}

export interface StatisticsHeaderItem {
  value: string | number;
  label: string;
  options?: StatisticsHeaderOptions;
}

export interface StatisticsHeader_Props {
  data: Array<StatisticsHeaderItem>;
}

const StatisticsHeader = (props: StatisticsHeader_Props) => {
  const getStatItem = (item: StatisticsHeaderItem) => {
    switch (item.label) {
      case items.MASTERY:
        return (
          <WoWSEntity
            type={items.MASTERY}
            id={item.value}
            className={styles.mastery}
            presentation={{
              withTooltip: true,
              renderWithoutFade: true,
            }}
          />
        );
      case items.MARK_OF_EXCELLENCE:
        return (
          <WoWSEntity
            type={ItemTypes.MARK_OF_EXCELLENCE}
            id={item.value}
            className={styles.markOfExcellence}
            presentation={{
              withTooltip: true,
              renderWithoutFade: true,
            }}
            customisation={{
              rewardReceiptDate: item.options?.achieved_at,
              avgXPPercentile: item.options?.percentile,
              battlesLeft: item.options?.battles_left,
            }}
          />
        );
      case items.MARK_OF_EXCELLENCE_DIVISION:
        return (
          <WoWSEntity
            type={ItemTypes.MARK_OF_EXCELLENCE_DIVISION}
            id={item.value}
            className={styles.markOfExcellence}
            presentation={{
              withTooltip: true,
              renderWithoutFade: true,
            }}
            customisation={{
              rewardReceiptDate: item.options?.achieved_at,
              avgXPPercentile: item.options?.percentile,
              battlesLeft: item.options?.battles_left,
            }}
          />
        );
      default:
        return (
          <>
            <div className={styles.title}>{item.value}</div>
            <div className={styles.label}>{item.label}</div>
          </>
        );
    }
  };

  if (!props.data || props.data.length === 0) {
    return (
      <Container>
        <Row>
          <Col>{'NO DATA'}</Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container>
      <Row className={styles.row}>
        {props.data.map((item: StatisticsHeaderItem, index: number) => {
          if (item.label === items.MASTERY && !item.value) {
            return null;
          }

          return (
            <Col className={styles.cell} key={`stat-item-${item.value}-${index}`}>
              {getStatItem(item)}
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default memo(StatisticsHeader);
